(() => {
  const initialize = () => {
    const home = document.getElementById('rbw-premium');
    if (home && !home.dataset.initialized) {
      home.dataset.initialized = 'true';
      const filters = home.querySelector('[data-rbw-filters]');
      if (filters) filters.hidden = false;
      const products = [...home.querySelectorAll('[data-rbw-color]')];
      home.querySelectorAll('[data-rbw-filter]').forEach(button => {
        button.addEventListener('click', () => {
          home.querySelectorAll('[data-rbw-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          products.forEach(product => { product.hidden = button.dataset.rbwFilter !== 'all' && product.dataset.rbwColor !== button.dataset.rbwFilter; });
          const status = home.querySelector('[data-rbw-filter-status]');
          if (status) status.textContent = button.textContent.trim();
        });
      });
      home.querySelectorAll('[data-rbw-open]').forEach(button => {
        const dialog = document.getElementById(button.dataset.rbwOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        button.hidden = false;
        button.addEventListener('click', () => { dialog.showModal(); });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => button.focus({ preventScroll: true }));
      });
      home.querySelectorAll('[data-rbw-variant]').forEach(input => {
        input.addEventListener('change', () => {
          const price = input.closest('dialog').querySelector('[data-rbw-price]');
          if (price && input.dataset.price) price.textContent = input.dataset.price;
        });
      });
      const hashTarget = document.getElementById(window.location.hash.slice(1));
      const dialog = hashTarget && hashTarget.closest('dialog');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    }
    const header = document.getElementById('rbw-site-header');
    if (header && !header.dataset.initialized) {
      header.dataset.initialized = 'true';
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => {
          document.body.style.setProperty('--header-group-height', `${header.offsetHeight}px`);
          document.body.style.setProperty('--header-height', `${header.querySelector('header').offsetHeight}px`);
        }).observe(header);
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

